if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super()
      }

      hide() {
        super.hide()
      }

      show(opener) {
        super.show(opener)
        this.showActiveMedia()
      }

      showActiveMedia() {
        // Hide all media items
        this.querySelectorAll('.product-media-modal__single-image').forEach(
          element => {
            element.style.display = 'none'
          },
        )

        // Show only the clicked media item
        const clickedMediaId = this.openedBy.getAttribute('data-media-id')
        const activeMedia = this.querySelector(
          `.product-media-modal__single-image[data-media-id="${clickedMediaId}"]`,
        )

        if (activeMedia) {
          activeMedia.style.display = 'flex'

          // Handle deferred media loading for videos
          const deferredMedia = activeMedia.querySelector('deferred-media')
          if (deferredMedia) {
            const activeMediaTemplate = deferredMedia.querySelector('template')
            const activeMediaContent = activeMediaTemplate
              ? activeMediaTemplate.content
              : null

            if (
              deferredMedia.nodeName == 'DEFERRED-MEDIA' &&
              activeMediaContent &&
              activeMediaContent.querySelector('.js-youtube')
            ) {
              deferredMedia.loadContent()
            }
          }
        }
      }
    },
  )
}
